import { Tag } from '@vrplatform/components';
import { useMantineTheme } from '@mantine/core';
import type { owner_type_enum } from '@vrplatform/graphql';
import { formatPercentage } from '@vrplatform/ui-common';
import { useOwnerDetailDrawer } from '../drawers/owner-drawers';

type Props = {
  ownerId: string;
  type: owner_type_enum;
  name: string;
  splitSuperBasePoints: number;
};

export const OwnerBadge = ({
  ownerId,
  type,
  name,
  splitSuperBasePoints,
}: Props) => {
  const { open: openOwnerDetailDrawer } = useOwnerDetailDrawer();

  const cent = splitSuperBasePoints / 1000;

  const theme = useMantineTheme();
  const color = type === 'company' ? 'violet' : theme.primaryColor;

  return (
    <Tag
      component="button"
      onClick={(e) => {
        e.stopPropagation();
        openOwnerDetailDrawer(ownerId);
      }}
      leftIcon={type === 'company' ? 'OfficeIcon' : 'UserIcon'}
      leftIconColor={(theme) => theme.colors[color][type === 'company' ? 7 : 5]}
      borderColor={theme.colors[color][1] + 60}
      backgroundColor={theme.colors[color][0] + 70}
    >
      {name}
      {cent === 100
        ? ''
        : ` (${formatPercentage(splitSuperBasePoints, 'super-base-points')})`}
    </Tag>
  );
};
